/** 资金流水**/
<template>
  <div class="capitalRecord">
    <div class="content">
      <div v-if="customerPreSaveSerials &&customerPreSaveSerials.length>0">
        <xk-capital-record-list :time="$utils.TimestampDate(item.time)"
                                :sum="item.cost ? item.cost.toFixed(1) : 0"
                                :type="item.style"
                                v-for="(item,index) in customerPreSaveSerials"
                                :key="index"
                                @click="actionFn(item.memo)">
        </xk-capital-record-list>
        <div class="queryList" @click="loadButFn" v-if="capitalRecords.content.length<capitalRecords.totalElements">
          <span>加载更多信息</span>
        </div>
      </div>
      <div v-else="" class="zanwujilv">
        <h2>暂无资金流水记录</h2>
      </div>
    </div>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
    <xk-alert-box :text="text" v-if="text!==''"></xk-alert-box>
  </div>
</template>

<script>
  import XkCapitalRecordList from '../../module/capitalRecordList/src/capitalRecordList'
  import Toucth from '../../../assets/js/method'
  import { mapGetters } from 'vuex'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod'
  import XkAlertBox from '../../module/alertBox/src/alertBox'

  export default {
    components: {
      XkAlertBox,
      XkUploadMod,
      XkCapitalRecordList
    },
    name: 'affirm',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        capitalRecords: 'capitalRecords'
      }),
      listFn () {
        let that = this
        let content = that.capitalRecords.content
        for (let i = 0; i < content.length; i++) {
          if (typeof content[i].recordCreatedStr !== 'string') {
            content[i].recordCreatedStr = Toucth.TimestampDate(content[i].recordCreatedStr)
          }
        }
        return content
      }
    },
    data () {
      return {
        page: 1,
        rows: 20,
        loadState: false,
        customerPreSaveSerials: [], // 列表
        text: ''
      }
    },
    methods: {
      loadButFn: function () {
        let that = this
        that.page++
        that.loadFn()
      },
      loadFn: function () {
        let that = this
        that.$store.dispatch('checkLogin', (state) => {
          if (state) {
            that.loadState = true
            that.$store.dispatch('getCustomerPreSaveSerials', {
              'cid': that.loginData.passenger.id,
              'page': that.page,
              'limit': that.rows,
              fn: (data) => {
                that.loadState = false
                if (data && data.code === 1) {
                  that.customerPreSaveSerials = data.customerPreSaveSerials
                }
              }
            })
          }
        })
      },
      actionFn: function (val) {
        if (val && val !== '') {
          this.text = val
        } else {
          this.text = '暂无信息'
        }
        setTimeout(() => {
          this.text = ''
        }, 1500)
      }
    },
    watch: {},
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.loadFn()
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .capitalRecord {
    padding-bottom: 1rem;
    .content {
      box-sizing: border-box;
      width: 100%;
      padding: 0 1rem;
      padding-top: 0.5rem;
      .capitalRecordList:nth-last-child(1):after {
        opacity: 0;
      }
      .zanwujilv {
        padding-top: 30vh;
        h2{
          text-align: center;
        }
      }
    }
    .queryList {
      box-sizing: border-box;
      width: 100%;
      padding: 0 1rem;
      line-height: 3rem;
      height: 3rem;
      span {
        box-sizing: border-box;
        width: 100%;
        text-align: center;
        color: #fff;
        background-color: #f06553;
        border-radius: 0.333rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// capitalRecord.vue?e213f37e